import ContactListing from '@/Component/Admin/GroupContacts/ContactListing'

const ContactsPage = () => {
  return (
    <ContactListing />
  )
}

export default ContactsPage
